
import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/module/common'
import { UserModule } from '@/store/module/user'

@Component({
  name: 'APP'
})
export default class extends Vue {
  created() {
    //UserModule.getUserInfo().then(() => {
    //  CommonModule.HANDLE_INIT_MENU(true)
    //})
  }

  get loadingStatus() {
    return CommonModule.globalLoading.length > 0
  }

  mounted() {
    const menuId = localStorage.getItem('menuId') || 'line'
    const subMenuId = localStorage.getItem('subMenuId') || 0
    CommonModule.SET_MENU_ID(menuId)
    CommonModule.SET_SUBMENU_ID(+subMenuId)
  }
}
